import { getAppI18nConfig, initI18n } from 'cfgi18n';
import type { GetStaticProps } from 'next';
import { lazy, Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
	getError500,
	GetError500Response,
	getSimpleFooter,
	GetSimpleFooterResponse,
} from 'services/idm';

import { useAppTranslation } from 'hooks/use-translates';

import { PUBLIC_BASE_URL_ENV } from 'tools/environments';

import { FormHeader } from '@login/components/form-header';

import { FormBox } from '../../../components/form-box/form-box';
import styles from './500.module.scss';

const Button = lazy(() => import('core/generic/elements/button'));

const Loading = lazy(() => import('core/generic/elements/loading'));

export type staticProps = {
	footerData: GetSimpleFooterResponse;
};

export const getStaticProps = (async (params) => {
	const locale = params?.locale as string;
	const { supportedLocales } = await getAppI18nConfig('login');
	await initI18n(locale, supportedLocales);
	const footerData = (await getSimpleFooter()) || [];
	return { props: { footerData, locale } };
}) satisfies GetStaticProps<staticProps>;

const ServerError = () => {
	const [pageData, setPageData] = useState<GetError500Response>();
	const { t } = useAppTranslation(pageData?.placeholders || {});
	const { i18n } = useTranslation();

	useEffect(() => {
		fetchData();
	}, []);

	const fetchData = async () => {
		const data = await getError500(i18n.language);
		if (data) {
			setPageData(data);
		}
	};

	return (
		<Suspense fallback={<Loading />}>
			<FormBox>
				<FormHeader headerTitle={t('common.anti_forgery_title')} />
				<div className={styles['content-wrapper']}>
					<p className="body-medium">
						{t('common.500_error_message')}
					</p>
					<div className={styles['btns-wrapper']}>
						<Button
							type="submit"
							label={t('signin.signin_button')}
							variant="primary"
							href={
								pageData?.placeholders?.signInUrl || '/signin'
							}
							className={styles.submitButton}
							dimension="large"
							fullWidth={true}
						/>
						<Button
							type="submit"
							label={t('common.back_to_site_button')}
							variant="tertiary"
							href={PUBLIC_BASE_URL_ENV}
							className={styles.submitButton}
							dimension="large"
							fullWidth={true}
						/>
					</div>
				</div>
			</FormBox>
		</Suspense>
	);
};

export default ServerError;
